import { executeRecaptcha } from 'lib/utils'
import { TeamInvitesClient } from '../types'

export const postInvite = (base: TeamInvitesClient) => async (invite: any) => {
  const token = await executeRecaptcha('teamInvite');
  return await base.requester.post<any>('', invite, { withCredentials: true, headers: { 'X-Proof': token } })
}
